import React, { useState } from "react";
import moment from "moment";

const TripClientsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";
  let additionalValues = props.additionalValues;

  if (!error && !record.origin) {
    error = true;
    errorMessage = "'Origin' is required";
  }
  if (!error && additionalValues && additionalValues.route) {
    if (additionalValues.route.indexOf(record.origin) < 0) {
      error = true;
      errorMessage = `'Origin' airport must be part of the Trip's route (${additionalValues.route})`;
    }
  }
  if (!error && !record.destination) {
    error = true;
    errorMessage = "'Destination' is required";
  }
  if (!error && additionalValues && additionalValues.route) {
    if (additionalValues.route.indexOf(record.destination) < 0) {
      error = true;
      errorMessage = `'Destination' airport must be part of the Trip's route (${additionalValues.route})`;
    }
  }
  if (!error && record.destination === record.origin) {
    error = true;
    errorMessage = "'Destination' airport cannot be the same as the 'Origin' airport";
  }
  if (!error && Array.isArray(record.uldStack) && record.uldStack.length > 0 && (isNaN(record.stackWeightKg) || record.stackWeightKg < 0)) {
    error = true;
    errorMessage = "A valid 'Stack Weight Kg' is required";
  }
  
  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default TripClientsValidator;
